export default {
  root: {
    position: 'relative'
  },
  button: {
    position: 'absolute',
    top: 29,
    height: 34,
    background: '#ededed',
    right: 0,
    cursor: 'pointer',
    borderTopRightRadius: 2,
    borderBottomRightRadius: 2,
    border: '1px solid #ccc',
    color: '#0070b9',
    textAlign: 'center',
    width: 53,
    padding: 0
  }
};
